import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/VictoryGardens";
import preloaderVideo from "./videos/load.mp4"; // Import if needed by ProjectMapPage internal logic or assets, but ProjectMapPage handles preloader.

const VictoryGardens6 = () => {
  const projectId = "PRJ00065";
  const title = "Victory Gardens Phase 6";

  const mapConfig = {
    minZoom: 5,
    zoom: 6.5,
    bounds: [
      [62.79, 16.19],
      [60.13, 23.57],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // Links seems to be missing or incorrect in legacy files (pointing to Achievers or using OG). 
      // Setting to null/disabled for safety until provided.
      viewProjectLink={null}
      fillOfferLink={null}
    />
  );
};

export default VictoryGardens6;
